const React = require('react')
const { Container, Row, Col } = require('reactstrap')

const { SearchAndBanner } = require('./searchAndBanner.beaconHome')
const { GeneralInfo } = require('./generalInfo.beaconHome')
const { LatestTable } = require('./latestTable.beaconHome')

require('@styles/pages/home/index.css')

const Home = props => {
    return (
        <div className='page'>
            <Container>
                <SearchAndBanner />
                <GeneralInfo />
                <div className='general-info'>
                    <Row>
                        <Col>
                            <Container fluid className='p-0'>
                                <Row className='mx-0'>
                                    <Col className='network-table' lg='6'>
                                        <LatestTable tableTitle='Slots' tableType='slots' />
                                    </Col>
                                    <Col className='network-table' lg='6'>
                                        <LatestTable tableTitle='Validators' tableType='validators' />
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

module.exports = React.memo(Home)
